import React, { useEffect, useState } from "react";
import Spinner from "../general/spinner";
import ReconciliationDeadlines from "./deadlines";
import ReconciliationMovements from "./movements";
import moment from "moment";
import "./style.css";
import ReconciliationLinkedToDeadlines from "./dialogs/linkedToDeadlines";
import { clearDeadlinesFromList, removeDeadlinesFromList } from "../../store/actions/deadlines/company";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { loadReconciliationMovements, setMovementLinked } from "../../store/actions/reconciliation/movements";
import { loadReconciliationAccounts } from "../../store/actions/reconciliation/accounts";
import { useIntl } from "react-intl";
import ModalDeadlinesBigger from "./modalDeadlinesBigger";
import ModalMovementsBigger from "./modalMovementsBigger";
import { createReconciliationLink, getReconcilableDeadlines, getReconciledSummary } from "../../store/actions/reconciliation/operations";
import ReconciledSummaryCounter from "./reconciledSummaryCounter";
import LoaderSimple from "../general/loader";
import { useReconciliation } from "../../customHooks/useReconciliation";
import { FEATURE_TOGGLE_ACCOUNTING } from "../../config";
import { delay } from "../../libs/utils";

const animationDuration = 1000; // Durata animazione in millisecondi

const ReconciliationPage = (props) => {
  const { openDeadlineDetail } = props;

  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const main = useSelector((state) => state.main);
  const reconciliation = useSelector((state) => state.reconciliation);
  const groupedDeadlines = reconciliation.operations?.reconcilableDeadlines?.suggestedDeadlinesGroups;
  const managerUuid = main.accountantUuidSelected;
  const itemUuid = main.companyUuidSelected;
  const [reconcilableDeadlines, setReconcilableDeadlines] = useState(reconciliation.operations?.reconcilableDeadlines?.filteredDeadlines);

  const [hasCompatibleDeadlines, setHasCompatibleDeadlines] = useState(false);

  const [disableReconciliationButton, setDisableReconciliationButton] = useState(false);
  const [isModalDeadlinesVisible, setIsModalDeadlinesVisible] = useState(false);
  const [isModalMovementsVisible, setIsModalMovementsVisible] = useState(false);
  const [selectedDeadlinesAmount, setSelectedDeadlinesAmount] = useState(0);
  const [difference, setDifference] = useState(0);
  const [paymentValueResidue, setPaymentValueResidue] = useState("PM05");
  const [checkbox, setCheckbox] = useState(false);
  const [dateValueResidue, setDateValueResidue] = useState(moment(new Date()));
  const [valueRadio, setValueRadio] = useState("1");
  const [deadlinesToReconcile, setDeadlinesToReconcile] = useState([]);
  const [filterDone, setFilterDone] = useState(false);

  const [invalidSelectionBiggerDeadlines, setInvalidSelectionBiggerDeadlines] = useState(null);

  const reconciliationHook = useReconciliation();

  const cancelText = useIntl().formatMessage({ id: "actions.cancel" });
  const saveText = useIntl().formatMessage({ id: "actions.save" });

  let saveTextMovements = useIntl().formatMessage({
    id: "reconciliation.deadlines.filter",
  });

  if (valueRadio === "2") {
    saveTextMovements = useIntl().formatMessage({
      id: "reconciliation.actions.saveAndLinkToMovement",
    });
  }

  if (valueRadio === "3") {
    saveTextMovements = useIntl().formatMessage({ id: "actions.save" });
  }

  if (valueRadio === "4") {
    saveTextMovements = useIntl().formatMessage({ id: "actions.save" });
  }

  const selectedMovementAmount = reconciliationHook.selectedMovementDetails.amount;

  useEffect(() => {
    dispatch(getReconciledSummary());
  }, [managerUuid, itemUuid]);

  useEffect(() => {
    const deadlines = reconciliationHook.selectedDeadlines?.flatMap((id) => {
      return reconcilableDeadlines?.filter((deadline) => deadline.id === id);
    });
    setDeadlinesToReconcile(deadlines);
  }, [reconciliationHook.selectedDeadlines, reconcilableDeadlines]);

  useEffect(() => {
    setDifference(Math.abs(selectedMovementAmount) - Math.abs(selectedDeadlinesAmount));
  }, [selectedMovementAmount, selectedDeadlinesAmount]);

  useEffect(() => {
    dispatch(loadReconciliationAccounts(auth, managerUuid, itemUuid))
      .then((res) => {
        let accountsFound = res.data.bankAccounts;
        if (accountsFound.length > 0) {
          dispatch(loadReconciliationMovements(auth, managerUuid, itemUuid, null, reconciliationHook.startDate, reconciliationHook.endDate));
        }
      })
      .catch((e) => {
        console.log("Error occurs");
      });
  }, []);

  useEffect(() => {
    dispatch(
      loadReconciliationMovements(auth, main.accountantUuidSelected, main.companyUuidSelected, null, reconciliationHook.startDate, reconciliationHook.endDate)
    );
  }, [reconciliationHook.startDate, reconciliationHook.endDate]);

  useEffect(() => {
    if (reconciliationHook.selectedMovements.length > 0) {
      reconciliationHook.setSelectedDeadlines([]);
      setSelectedDeadlinesAmount(0);
    } else {
      dispatch(clearDeadlinesFromList());
    }
    setFilterDone(false);
  }, [reconciliationHook.selectedMovements]);

  useEffect(() => {
    if (!main.widgets.fullscreenOverlay.visible) {
      if (reconciliationHook.latestLinkedTo) {
        reconciliationHook.setVisibleLinkedToDialog(reconciliationHook.latestLinkedTo);
      }
    }
  }, [main.widgets.fullscreenOverlay.visible]);

  const isGettingReconcilableDeadlines = useSelector((state) => state.reconciliation?.isGettingReconcilableDeadlines);

  const hasSameScore = () => {
    let score = groupedDeadlines && groupedDeadlines[0] ? groupedDeadlines[0].score : null;
    for (let item in groupedDeadlines) {
      if (item.score !== score) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (!isGettingReconcilableDeadlines) {
      let orderdGroups = [];
      // Se hanno tutti lo stesso score non lo ordine e prendo il primo
      if (groupedDeadlines) {
        if (hasSameScore()) {
          orderdGroups = groupedDeadlines;
        } else {
          orderdGroups = groupedDeadlines.sort((a, b) => (a.score < b.score ? 1 : -1));
        }
      }
      setHasCompatibleDeadlines(false);
      let deadlineListSel = [];
      if (orderdGroups.length !== 0) {
        deadlineListSel.push(orderdGroups[0].deadlineIdList);
        reconciliationHook.setSelectedDeadlines(deadlineListSel[0]);
        setHasCompatibleDeadlines(true);
      } else {
        if (reconcilableDeadlines && reconcilableDeadlines.length !== 0 && reconcilableDeadlines[0].reconciliationHints.rank !== 0) {
          reconciliationHook.setSelectedDeadlines([reconcilableDeadlines[0].id]);
          setHasCompatibleDeadlines(true);
        }
      }
    }
  }, [reconcilableDeadlines]);

  useEffect(() => {
    let total = 0;
    let allDeadline = reconcilableDeadlines;
    if (!filterDone) {
      for (let d in reconciliationHook.selectedDeadlines) {
        if (reconciliationHook.selectedDeadlines.hasOwnProperty(d)) {
          let deadlineDetail = allDeadline?.find((deadline) => deadline.id === reconciliationHook.selectedDeadlines[d]);
          total += Math.abs(deadlineDetail?.totalAmount);
        }
      }
      setSelectedDeadlinesAmount(total);
    }
  }, [reconciliationHook.selectedDeadlines]);

  useEffect(() => {
    if (reconciliationHook.selectedMovements.length !== 0) {
      dispatch(getReconcilableDeadlines(reconciliationHook.selectedMovements, reconciliationHook.startDate, reconciliationHook.endDate)).then((response) =>
        setReconcilableDeadlines(response?.data.filteredDeadlines)
      );
    }
  }, [reconciliationHook.selectedMovements]);

  useEffect(() => {
    if (reconciliationHook.activeFilters?.length === 0) {
      reconciliationHook.setActiveFilters(["all"]);
    }
  }, [reconciliationHook.activeFilters]);

  const selectFirstUnlinkedMovement = () => {
    let alreadyDone;
    if (Object.keys(reconciliation.movements.list).length > 0) {
      reconciliation.movements.list.map((movement) => {
        if (!movement.linked && !alreadyDone) {
          alreadyDone = true;
          reconciliationHook.setSelectedMovements([movement.id]);
          reconciliationHook.setSelectedMovementDetails(movement);
        }
        return null;
      });
      /* periods.map(period => {
        if (reconciliation.movements.list[period] && !alreadyDone) {
          reconciliation.movements.list[period].map(movement => {
            if (!movement.linked && !alreadyDone) {
              alreadyDone = true;
              setSelectedMovements([movement.id]);
              setSelectedMovementDetails(movement);
            }
            return null;
          });
        }
        return null;
      });*/
    }
    if (!alreadyDone) {
      reconciliationHook.setSelectedMovements([]);
      reconciliationHook.setSelectedMovementDetails({});
    }
    return;
  };

  const makeCardAnimation = () => {
    let x;
    let y;
    let trgtH;
    $(".dbx-reconciliation-movement-card.selected").each(function (index) {
      // $(window).scrollTop($(this).offset().top);
      x = $(this).offset().left;
      y = $(this).offset().top;
      trgtH = $(this).height();
    });

    $(".dbx-reconciliation-deadlines-block-container.selected").each(function (index) {
      let xi = $(this).offset().left;
      let yi = $(this).offset().top;
      let elH = $(this).height();
      $(this).css("left", xi).css("top", yi).addClass("dragAnimation");
      $(this).animate(
        {
          left: x,
          top: y,
          height: elH > trgtH ? "-=" + (elH - trgtH) + "px" : "",
        },
        animationDuration
      );
    });
    setTimeout(() => {
      afterReconciliationEnd();
    }, animationDuration);
  };

  const afterReconciliationEnd = () => {
    const movementToLink = reconciliationHook.selectedMovements[0];
    // Rimuovo scadenze selezionate dalla lista scadenze
    dispatch(removeDeadlinesFromList(reconciliationHook.selectedDeadlines));
    // Rimuovo scadenze selezionate dallo state
    reconciliationHook.setSelectedDeadlines([]);
    // Aggiungo attributo isLinked al movimento bancario attivo, e succesivamente lo deseleziono
    dispatch(setMovementLinked(movementToLink));
    // Infine rimuovo classi e stili temporaneamente assegnati per l'animazione di spostamento
    $(".dbx-reconciliation-deadlines-block-container").each(function (index) {
      $(this).css("left", "").css("top", "").css("height", "").removeClass("selected");
    });
    // Riattivo il pulsante dell'associazione
    setDisableReconciliationButton(false);
    // Seleziono il primo movimento non ancora associato dall'elenco movimenti
    selectFirstUnlinkedMovement();
  };

  const checkAmountDeadlinesDifferences = () => {
    if (difference < 0) {
      return true;
    }
    return false;
  };

  const checkAmountMovementsDifferences = () => {
    if (difference > 0) {
      return true;
    }
    return false;
  };

  const onReconciliationButtonClick = () => {
    setIsModalDeadlinesVisible(checkAmountDeadlinesDifferences);
    setIsModalMovementsVisible(checkAmountMovementsDifferences);
    let linkList = [];
    let deadlineIdsList = reconciliationHook.selectedDeadlines;
    let bankTransactionId = reconciliationHook.selectedMovements[0];
    deadlineIdsList.forEach((deadlineId) => linkList.push({ deadlineId, bankTransactionId }));
    if (difference === 0) {
      dispatch(createReconciliationLink(auth, main.accountantUuidSelected, main.companyUuidSelected, linkList, "BANK_TRANSACTION")).then((res) =>
        delay(3000).then(() => dispatch(getReconciledSummary()))
      );
      reconciliationHook.setBlockMask();
      setDisableReconciliationButton(true);
      makeCardAnimation();
      dispatch(getReconcilableDeadlines(reconciliationHook.selectedMovements, reconciliationHook.startDate, reconciliationHook.endDate)).then((response) =>
        setReconcilableDeadlines(response?.data.filteredDeadlines)
      );
    }
  };

  const handleSelectedDeadlines = (value, deadline) => {
    let tmpSelected = [...reconciliationHook.selectedDeadlines];
    if (reconciliationHook.selectedDeadlines.indexOf(value) > -1) {
      tmpSelected.splice(reconciliationHook.selectedDeadlines.indexOf(value), 1);
      handleRemoveDeadlineFromTotal(deadline);
    } else {
      tmpSelected.push(value);
      setSelectedDeadlinesAmount(Math.abs(selectedDeadlinesAmount) + Math.abs(deadline.totalAmount));
    }
    reconciliationHook.setSelectedDeadlines(tmpSelected);
    return null;
  };

  const handleRemoveDeadlineFromTotal = (deadline) => {
    const filteredSelectedDeadlines = reconciliationHook.selectedDeadlines.filter((d) => d !== deadline.id);
    reconciliationHook.setSelectedDeadlines(filteredSelectedDeadlines);
    const newTotalAmount = Math.abs(selectedDeadlinesAmount) - Math.abs(deadline.totalAmount);
    setSelectedDeadlinesAmount(newTotalAmount);
  };

  const reconciledSummary = reconciliation?.reconciledSummary;
  const isGettingReconciledSummary = reconciliation?.isGettingReconciledSummary;
  const isReconciledSummaryError = reconciliation?.isReconciledSummaryError;

  return (
    <>
      {(reconciledSummary?.reconciliationsCreated > 0 || reconciledSummary?.notReconcilable > 0) &&
      !isGettingReconciledSummary &&
      FEATURE_TOGGLE_ACCOUNTING === "true" ? (
        <ReconciledSummaryCounter reconciledSummary={reconciledSummary} auth={auth} itemUuid={itemUuid} managerUuid={managerUuid} />
      ) : isGettingReconciledSummary && !isReconciledSummaryError && FEATURE_TOGGLE_ACCOUNTING === "true" ? (
        <div className="dbx-reconciliation-summary-loader-container">
          <LoaderSimple />
        </div>
      ) : null}
      <div className="dbx-reconciliation-page-root">
        <ModalDeadlinesBigger
          difference={difference}
          isModalVisible={isModalDeadlinesVisible}
          setIsModalVisible={setIsModalDeadlinesVisible}
          cancelText={cancelText}
          saveText={saveText}
          selectedMovementDetails={reconciliationHook.selectedMovementDetails}
          selectedDeadlinesAmount={selectedDeadlinesAmount}
          paymentValueResidue={paymentValueResidue}
          setPaymentValueResidue={setPaymentValueResidue}
          checkbox={checkbox}
          setCheckbox={setCheckbox}
          dateValueResidue={dateValueResidue}
          setDateValueResidue={setDateValueResidue}
          valueRadio={valueRadio}
          setValueRadio={setValueRadio}
          openDeadlineDetail={openDeadlineDetail}
          selectedDeadlines={reconciliationHook.selectedDeadlines}
          invalidSelectionBiggerDeadlines={invalidSelectionBiggerDeadlines}
          setInvalidSelectionBiggerDeadlines={setInvalidSelectionBiggerDeadlines}
          reconcilableDeadlines={reconcilableDeadlines}
          deadlinesToReconcile={deadlinesToReconcile}
          createReconciliationLink={createReconciliationLink}
          setBlockMask={reconciliationHook.setBlockMask}
          setDisableReconciliationButton={setDisableReconciliationButton}
          getReconcilableDeadlines={getReconcilableDeadlines}
          setReconcilableDeadlines={setReconcilableDeadlines}
          selectedMovements={reconciliationHook.selectedMovements}
          startDate={reconciliationHook.startDate}
          endDate={reconciliationHook.endDate}
          makeCardAnimation={makeCardAnimation}
        />
        <ModalMovementsBigger
          difference={difference}
          isModalVisible={isModalMovementsVisible}
          setIsModalVisible={setIsModalMovementsVisible}
          selectedMovementDetails={reconciliationHook.selectedMovementDetails}
          cancelText={cancelText}
          saveText={saveTextMovements}
          valueRadio={valueRadio}
          setValueRadio={setValueRadio}
          movementAmount={selectedMovementAmount}
          amountToPay={selectedDeadlinesAmount}
          selectedDeadlines={reconciliationHook.selectedDeadlines}
          setSelectedDeadlines={reconciliationHook.setSelectedDeadlines}
          handleSelectedDeadlines={handleSelectedDeadlines}
          afterReconciliationEnd={afterReconciliationEnd}
        />
        {reconciliation.accounts.status.started ? (
          <div className="dbx-reconciliation-page-loading">
            <Spinner size="large" tip="Caricamento conti correnti ..." />
          </div>
        ) : (
          <React.Fragment>
            {reconciliationHook.visibleLinkedToDialog && (
              <ReconciliationLinkedToDeadlines
                visible={reconciliationHook.visibleLinkedToDialog}
                onClose={() => {
                  reconciliationHook.setVisibleLinkedToDialog(false);
                  reconciliationHook.setLatestLinkedTo(null);
                }}
                movement={reconciliationHook.visibleLinkedToDialog}
                openDeadlineDetail={openDeadlineDetail}
                setVisibleLinkedToDialog={reconciliationHook.setVisibleLinkedToDialog}
                auth={auth}
                managerUuid={managerUuid}
                itemUuid={itemUuid}
                startDate={reconciliationHook.startDate}
                endDate={reconciliationHook.endDate}
                loadReconciliationMovements={loadReconciliationMovements}
              />
            )}
            <ReconciliationMovements
              onFiltersMovementsChange={reconciliationHook.onFiltersMovementsChange}
              onLinkedToClick={(value) => {
                reconciliationHook.setVisibleLinkedToDialog(value);
                reconciliationHook.setLatestLinkedTo(value);
              }}
              selectedDeadlines={reconciliationHook.selectedDeadlines}
              selectedMovements={reconciliationHook.selectedMovements}
              setSelectedMovements={reconciliationHook.setSelectedMovements}
              setSelectedMovementDetails={reconciliationHook.setSelectedMovementDetails}
              blockMask={reconciliationHook.blockMask}
              setStartDate={reconciliationHook.setStartDate}
              setEndDate={reconciliationHook.setEndDate}
              startDate={reconciliationHook.startDate}
              endDate={reconciliationHook.endDate}
              activeFilters={reconciliationHook.activeFilters}
              isAccountingPage={false}
              filterDateRange={reconciliationHook.filterDateRange}
              setFilterDateRange={reconciliationHook.setFilterDateRange}
            />
            <ReconciliationDeadlines
              selectedDeadlines={reconciliationHook.selectedDeadlines}
              selectedMovements={reconciliationHook.selectedMovements}
              selectedMovementDetails={reconciliationHook.selectedMovementDetails}
              setSelectedDeadlines={reconciliationHook.setSelectedDeadlines}
              selectedDeadlinesAmount={selectedDeadlinesAmount}
              setSelectedDeadlinesAmount={setSelectedDeadlinesAmount}
              openDeadlineDetail={openDeadlineDetail}
              onReconciliationButtonClick={onReconciliationButtonClick}
              blockMask={reconciliationHook.blockMask}
              disableReconciliationButton={disableReconciliationButton}
              deadlines={reconcilableDeadlines}
              isGettingDeadlines={isGettingReconcilableDeadlines}
              handleSelectedDeadlines={handleSelectedDeadlines}
              handleRemoveDeadlineFromTotal={handleRemoveDeadlineFromTotal}
              invalidSelectionBiggerDeadlines={invalidSelectionBiggerDeadlines}
              setInvalidSelectionBiggerDeadlines={setInvalidSelectionBiggerDeadlines}
              difference={difference}
              hasCompatibleDeadlines={hasCompatibleDeadlines}
              groupedDeadlines={groupedDeadlines}
              itemUuid={itemUuid}
              managerUuid={managerUuid}
              afterReconciliationEnd={afterReconciliationEnd}
              filterDone={filterDone}
              setFilterDone={setFilterDone}
            />
          </React.Fragment>
        )}
      </div>
    </>
  );
};

export default ReconciliationPage;
